export const SpaceRecentListService = Symbol.for('SpaceRecentListService');
